import * as yup from 'yup';

export const schema = yup.object({
  des_numero_tipo: yup.string().required(),
  num_tipo_item: yup.string().required(),
});
